import { render, staticRenderFns } from "./BmpDialog.vue?vue&type=template&id=a9ba2f0c"
import script from "./BmpDialog.vue?vue&type=script&lang=js"
export * from "./BmpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports